import React from 'react';
import img1 from '../assets/images/harin.jpg';
import img2 from '../assets/images/sansika.jpg';
import img3 from '../assets/images/prasanna.jpg';
import img4 from '../assets/images/sanushita.jpg';

function AboutUs() {
  return (
    <div className="bg-[#fdf4e4]  px-6 md:px-24 text-[#3f3a32]">
      <div className="flex flex-col md:flex-row justify-between items-start gap-16">

        {/* Business Leadership */}
        <div className="w-full md:w-2/5">
          <h2 className="text-2xl md:text-3xl font-bold mb-10 font-mortend headings">BUSINESS LEADERSHIP</h2>
          <ul className="space-y-4">
  {[
    {
      name: 'Harin Wickramasinghe',
      role: 'Producer',
      img: img1,
    },
    {
      name: 'Sansika Mahatantila',
      role: 'Director',
      img: img2,
    },
    {
      name: 'Prasanna Weerakkody',
      role: 'Art Director',
      img: img3,
    },
    {
      name: 'Sanushitha Goonetilleke',
      role: 'Sound Director',
      img: img4,
    },
  ].map((leader, index) => (
    <li key={index} className="flex items-center gap-4 mb-2">
      <img
        src={leader.img}
        alt={leader.name}
        className="w-10 h-10 rounded-full object-cover"
      />
      <div className="leading-tight">
        <p className="font-semibold">{leader.name}</p>
        <p className="text-sm text-[#7c623f] mb-2">{leader.role}</p>
      </div>
    </li>
  ))}
</ul>

        </div>

        {/* Right Side Text */}
        <div className="w-full md:w-3/5">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 font-mortend headings">BUILT ON HISTORY, CRAFTED WITH PRECISION.</h2>

          <div className="space-y-4 text-sm md:text-base">
            <div>
              <h3 className="text-lg font-semibold mb-3">Authenticity Matters</h3>
              <p className='leading-relaxed text-base'>
                Sigiriya VR is more than just a visual experience—it’s a <strong>historically faithful reconstruction</strong>,
                crafted with guidance from archaeologists and Sri Lankan history experts. Our work is grounded
                in sources like the <strong>Mahavamsa</strong> and <strong>Culavamsa</strong>, as well as real-world archaeological studies.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-3">Our Process</h3>
              <ol className="list-decimal list-inside space-y-1 leading-relaxed text-base">
                <li><strong>Historical Research</strong> – Consulting primary sources and expert opinions.</li>
                <li><strong>3D Reconstruction</strong> – Accurately modeling structures, landscapes, and artwork.</li>
                <li><strong>Verification</strong> – Ensuring every detail aligns with available evidence.</li>
              </ol>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default AboutUs;